// extracted by mini-css-extract-plugin
export var actions = "_1m-0";
export var actionsContainer = "_1m-7";
export var border = "_1m-1";
export var childFullHeight = "_1m-f";
export var collapse = "_1m-2";
export var content = "_1m-a";
export var contentChild = "_1m-e";
export var fullscreen = "_1m-c";
export var hasLeftRadius = "_1m-k";
export var headerContainer = "_1m-3";
export var headerRow = "_1m-5";
export var hidePadding = "_1m-b";
export var navCollapsedGap = "_1m-l";
export var noScrollX = "_1m-m";
export var noScrollY = "_1m-n";
export var noTopPadding = "_1m-i";
export var optOutTopPadding = "_1m-d";
export var pageMain = "_1m-j";
export var pageOuter = "_1m-g";
export var pagePadding = "_1m-8";
export var pageScroll = "_1m-9";
export var profile = "_1m-o";
export var profileContainer = "_1m-p";
export var profileImage = "_1m-q";
export var profileMain = "_1m-r";
export var profileSubtitle = "_1m-t";
export var profileTitle = "_1m-s";
export var showLeftPadding = "_1m-h";
export var tabsPortalSlot = "_1m-6";
export var tabsWrapper = "_1m-4";
export var title = "_1m-u";